<h2 mat-dialog-title>Ubah Password</h2>
<mat-dialog-content class="mat-typography">
    <div>
        <mat-label>Tanda Tangan</mat-label>
        <div class="text-center signature-container">
            <button *ngIf="!showSignature" mat-flat-button color="warn" (click)="editSignature()">
                {{ this.biodata.tandaTangan ? 'Ubah' : 'Tambah' }} Tanda Tangan
            </button>
            <img *ngIf="!showSignature" src="{{ biodata.tandaTangan }}" class="signature-image mt-2" />
            <button *ngIf="showSignature" mat-flat-button color="primary" (click)="saveSignature()">
                Simpan Tanda Tangan
            </button>
            <button *ngIf="showSignature" mat-flat-button color="warn" (click)="clearSignature()">
                Hapus Tanda Tangan
            </button>
            <signature-pad *ngIf="showSave" style="background: #ffffff" class="mt-2" #signature
                [options]="signaturePadOptions"></signature-pad>
        </div>

        <div class="text-center mt-3">
            <mat-progress-bar *ngIf="isLoading" class="mt-1" mode="indeterminate"></mat-progress-bar>
        </div>
    </div>
</mat-dialog-content>